import BaseService from './BaseService';
import { camelizeKeys } from 'humps';

const objectType = 'assays';

class AssaysService extends BaseService {

  static getList() {

    return super.get('lookup/assays?paginate=false')
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static create(data) {
    return super.post(objectType, `lookup/assays`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    return super.patch(objectType, `lookup/assays/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`lookup/assays/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

}

export default AssaysService;